import React, { Component } from 'react';
import { Modal, Table, Grid, Row, Col, ButtonToolbar, Button } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { TableButton } from '../../TableButton';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { IntervalForm } from './IntervalForm';

import ColumnResize from "react-table-column-resizer";

export class Intervals extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
    }

    constructor(props) {
        super(props);

        this.state = {
            table: {
                data: [],
                page: 1,
                totalPages: 1,
                elementsPerPage: 50
            },
            form: {
                title: undefined,
                interval: undefined,
                original: undefined,
            },
            actions: {
                isLoading: true,
                isUpdating: false
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };

        this.getData();
    }

    // ---------------------------

    getData(resetActions = false) {
        if (resetActions) {
            const { actions } = this.state;

            actions.isLoading = true;

            this.setState({
                actions: actions
            });
        }

        this.props.command.getIntervals(
            this.props.edition,
            this.props.elementId,
            (a) => this.listSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isLoading")
        );
    }

    onSave() {
        const { table, actions } = this.state;

        actions.isUpdating = true;

        this.props.command.saveIntervals(
            this.props.edition,
            this.props.elementId,
            table.data,
            (a) => this.operationSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        this.setState({
            actions: actions
        });
    }

    listSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table,
            actions: actions
        });
    }

    operationSuccessCallback(result) {
        const messageObj = {
            message: result.message,
            style: "success",
            title: "Sucesso",
            icon: "ok"
        };

        this.props.onHide(messageObj);
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    // -----------------------

    handleEditClick(interval) {
        const { form } = this.state;

        form.original = interval;
        form.interval = Object.assign({}, interval);
        form.title = "Editar";

        this.setState({
            form: form
        });
    }

    handleAddClick() {
        const { form } = this.state;

        form.original = null;
        form.interval = {
            begin: null,
            end: null,
            type: 0
        };
        form.title = "Adicionar";

        this.setState({
            form: form
        });
    }

    handleDeleteClick(interval) {
        const { table } = this.state;

        table.data = table.data.filter(data => data !== interval);

        this.setState({
            table: table
        });
    }

    handleIntervalSave(interval) {
        const { form } = this.state;

        if (null === form.original) {
            const { table } = this.state;
            table.data.push(interval);
        }
        else {
            if (interval.type !== form.original.type) {
                form.original.id = 0;
            }

            form.original.begin = interval.begin;
            form.original.end = interval.end;
            form.original.type = interval.type;
        }

        this.handleIntervalExit();
    }

    handleIntervalExit() {
        const { form } = this.state;

        form.original = undefined;
        form.interval = undefined;
        form.title = undefined;

        this.setState({
            form: form
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ---------------------------

    renderStateIcon(state) {
        if (0 === state) {
            return (<div className={"icon-img icon-ok"}></div>);
        }
        else if (1 === state) {
            return (<div className={"icon-img icon-error"}></div>);
        }

        return null;
    }

    renderStateText(state) {
        if (0 === state) {
            return "Ativo";
        }
        else if (1 === state) {
            return "Inativo";
        }

        return null;
    }

    renderDate(date) {
        if (undefined === date || null === date) {
            return null;
        }

        const output = new Date(date);
        let year = `${output.getFullYear()}`;
        let month = `${output.getMonth() + 1}`;
        let day = `${output.getDate()}`;

        if (1 === month.length) {
            month = `0${month}`;
        }

        if (1 === day.length) {
            day = `0${day}`;
        }

        switch (year.length) {
            case 1:
                year = `000${year}`;
                break;
            case 2:
                year = `00${year}`;
                break
            case 3:
                year = `0${year}`;
                break;
            default:
                break;
        }

        return `${year}-${month}-${day}`;
    }

    renderForm() {
        const { form } = this.state;

        if (null === form.interval || undefined === form.interval) {
            return null;
        }

        return (
            <IntervalForm title={form.title}
                interval={form.interval}
                onSave={(a) => this.handleIntervalSave(a)}
                onHide={() => this.handleIntervalExit()} />
        );
    }

    renderTable(isWaiting) {
        if (isWaiting) {
            return (
                <Modal show={true} bsSize="large">
                    <Modal.Header>
                        <Modal.Title>Periodos de Funcionamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <LoadingSpinner />
                    </Modal.Body>
                </Modal>
            )
        }

        const { table } = this.state;

        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <Modal show={true} bsSize="large">
                <Modal.Header>
                    <Modal.Title>Periodos de Funcionamento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Grid fluid>
                        <Row>
                            <Col sm={12}>
                                <Table responsive striped hover style={{ marginTop: 10 }}>
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>Estado</th>
                                            <ColumnResize className="columnResizer" />
                                            <th>Data Início</th>
                                            <ColumnResize className="columnResizer" />
                                            <th>Data Fim</th>
                                            <ColumnResize className="columnResizer" />
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            partialData.map((data, idx) =>
                                                <tr key={`interval-${idx}`}>
                                                    <td width="1px">{this.renderStateIcon(data.type)}</td>
                                                    <td className="column_resizer_body" />
                                                    <td>{this.renderStateText(data.type)}</td>
                                                    <td className="column_resizer_body" />
                                                    <td>{this.renderDate(data.begin)}</td>
                                                    <td className="column_resizer_body" />
                                                    <td>{this.renderDate(data.end)}</td>
                                                    <td className="column_resizer_body" />
                                                    <td>
                                                        <ButtonToolbar className="pull-right">
                                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.handleEditClick(data)} />
                                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteClick(data)} />
                                                        </ButtonToolbar>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>

                                <PaginationBuilder
                                    currentPage={table.page}
                                    elementsPerPage={table.elementsPerPage}
                                    dataLength={table.data.length}
                                    onChangePage={(a) => this.onChangePage(a)}
                                    onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                            </Col>
                        </Row>
                    </Grid>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR ALTERAÇÕES </Button>
                        <Button className="pull-right" onClick={() => this.handleAddClick()}> ADICIONAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        const { actions, message } = this.state;

        return (
            <div>
                {this.renderTable(actions.isLoading || actions.isUpdating)}
                {this.renderForm()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}
